export default __webpack_public_path__ + "static/media/img-0384-switzerland-half-face.d7083fe1.png";